export const SEARCH_TYPES = {
  internal: 'MOVER',
  gruzovichkof: 'Грузовичкоф',
  avtoflot: 'Автофлот',
  vozovoz: 'Возовоз'
}
